import { SubText } from '../../../../components/Prompt/Prompt.component';
import { useOpenAlert } from '../../../../Context/Layout.context';
import { ITaskGroup } from '../../../../models/taskGroup.types';
import { SelectedExaminer } from '../../../../services/examiners/examiners.types';
import {
  deleteExaminingTeamChairman,
  deleteSampleAssessmentGroup,
  unassignExaminingTeamChairman,
  UnassignExaminingTeamMember,
  updateExaminerNumber,
} from '../../../../services/exams/examiningTeam/examiningTeam.service';
import {
  deleteAssessmentTeamMember,
  unassignSampleGroupAssesmentChairman,
} from '../../../../services/exams/sampleAssessmentGroup/sampleAssessmentGroup.service';

export type UseExaminerTreemapApiActionsProps = {
  setPromptSubTexts: React.Dispatch<React.SetStateAction<SubText[] | undefined>>;
  setPromptMainText: React.Dispatch<React.SetStateAction<string>>;
  selectedItemId: React.MutableRefObject<string>;
  selectedTaskGroup: React.MutableRefObject<ITaskGroup | undefined>;
  removedExaminatorFromZeByTeamMemberIdRef: React.MutableRefObject<string>;
  closeMenu: () => void;
  setIsSuccessPromptVisible: React.Dispatch<React.SetStateAction<boolean>>;
  reload: () => void;
  setIsErrorPromptVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setEditExaminerNumberModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useExaminerTreemapApiActions = ({
  selectedItemId,
  selectedTaskGroup,
  removedExaminatorFromZeByTeamMemberIdRef,
  setPromptMainText,
  setPromptSubTexts,
  closeMenu,
  reload,
  setIsErrorPromptVisible,
  setIsSuccessPromptVisible,
  setEditExaminerNumberModalOpen,
}: UseExaminerTreemapApiActionsProps) => {
  const openAlert = useOpenAlert();

  const removeExaminignTeamChairmanAssignment = () => {
    setPromptMainText('Usunięcie przypisanej funkcji PZE Egzaminatorowi:');
    const subTexts: SubText[] = [];
    if (selectedTaskGroup.current) {
      subTexts.push({
        text: `${
          selectedTaskGroup.current.examTaskGroupCoordinators
            .find((coordinator) =>
              coordinator.examiningTeamChairmen.find((chairman) => chairman.teamChairmanId === selectedItemId.current),
            )
            ?.examiningTeamChairmen.find((chairman) => chairman.teamChairmanId == selectedItemId.current)?.examiner
            .firstName
        } ${
          selectedTaskGroup.current.examTaskGroupCoordinators
            .find((coordinator) =>
              coordinator.examiningTeamChairmen.find((chairman) => chairman.teamChairmanId === selectedItemId.current),
            )
            ?.examiningTeamChairmen.find((chairman) => chairman.teamChairmanId == selectedItemId.current)?.examiner
            .lastName
        }`,
      });
    }
    unassignExaminingTeamChairman(selectedItemId.current).then(
      () => {
        subTexts.push({ text: 'zakończone sukcesem.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsSuccessPromptVisible(true);
        closeMenu();
        reload();
      },
      () => {
        subTexts.push({
          text: 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const removeExaminingTeamChairmanFunction = () => {
    setPromptMainText('Usunięcie funkcji PZE z:');
    const subTexts: SubText[] = [];
    if (selectedTaskGroup.current) {
      subTexts.push({ text: selectedTaskGroup.current.name });
    }

    deleteExaminingTeamChairman(selectedItemId.current).then(
      () => {
        subTexts.push({ text: 'zakończone sukcesem.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsSuccessPromptVisible(true);
        closeMenu();
        reload();
      },
      () => {
        subTexts.push({
          text: 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const removeSampleAssessmentChairmanAssignment = () => {
    setPromptMainText('Usunięcie przypisanej funkcji Przewodniczącego ZWO Egzaminatorowi:');
    const subTexts: SubText[] = [];
    if (selectedTaskGroup.current) {
      subTexts.push({
        text: `${selectedTaskGroup.current.sampleAssessmentGroup?.sampleAssessmentChairman.examiner.firstName} ${selectedTaskGroup.current.sampleAssessmentGroup?.sampleAssessmentChairman.examiner.lastName}`,
      });
    }
    unassignSampleGroupAssesmentChairman(selectedItemId.current).then(
      () => {
        subTexts.push({ text: 'zakończone sukcesem.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsSuccessPromptVisible(true);
        reload();
      },
      () => {
        subTexts.push({
          text: 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const removeSampleAssessmentGroup = () => {
    setPromptMainText('Usunięcie Zespołu Wzorcowych Ocen (ZWO) z:');
    const subTexts: SubText[] = [];
    if (selectedTaskGroup.current) {
      subTexts.push({
        text: `${selectedTaskGroup.current.name}`,
      });
    }
    deleteSampleAssessmentGroup(selectedItemId.current).then(
      () => {
        subTexts.push({ text: 'zakończone sukcesem.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsSuccessPromptVisible(true);
        reload();
      },
      () => {
        subTexts.push({
          text: 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const removeSampleAssessmentMemberAssignment = () => {
    deleteAssessmentTeamMember(selectedItemId.current).then(
      () => {
        openAlert('success');
        reload();
      },
      () => {
        setPromptMainText('Nie można usunąć członka ZWO:');
        const subTexts: SubText[] = [];
        if (selectedTaskGroup.current) {
          subTexts.push({
            text: `${
              selectedTaskGroup.current.sampleAssessmentGroup?.sampleAssessmentMembers.find(
                (member) => member.sampleAssessmentMemberId === selectedItemId.current,
              )?.examiner.firstName
            } ${
              selectedTaskGroup.current.sampleAssessmentGroup?.sampleAssessmentMembers.find(
                (member) => member.sampleAssessmentMemberId === selectedItemId.current,
              )?.examiner.lastName
            }`,
          });
        }
        subTexts.push({ text: 'ponieważ przynajmniej jedno RGZ zostało', isBold: true });
        subTexts.push({ text: 'ocenione i odesłane do weryfikacji.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const removeVerifierFunction = () => {
    UnassignExaminingTeamMember(removedExaminatorFromZeByTeamMemberIdRef.current).then(
      () => {
        openAlert('success');
        reload();
      },
      () => {
        setPromptMainText('Nie można usunąć funkcji Egzaminator-Weryfikator:');
        const subTexts: SubText[] = [];
        subTexts.push({ text: 'Wystąpił błąd podczas usuwania funkcji.', isBold: true });
        setPromptSubTexts(subTexts);
        setIsErrorPromptVisible(true);
      },
    );
  };

  const handleUpdateExaminerNumber = (data: SelectedExaminer[]) => {
    if (!data[0].id || !data[0].examinerNumber) return;
    updateExaminerNumber(data[0].id, data[0].examinerNumber).then(
      () => {
        openAlert('success');
        setEditExaminerNumberModalOpen(false);
        reload();
      },
      () => {
        openAlert('error');
      },
    );
  };

  return {
    handleUpdateExaminerNumber,
    removeExaminignTeamChairmanAssignment,
    removeExaminingTeamChairmanFunction,
    removeSampleAssessmentChairmanAssignment,
    removeSampleAssessmentGroup,
    removeSampleAssessmentMemberAssignment,
    removeVerifierFunction,
  };
};
